import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useTeamsContext } from "../../../../state/teams/context";
import updateFieldSelectorStyles from "../../styles/UpdateFieldSelector.styles";
import { useGameContextContext } from "../../../../state/game-context/context";
import TeamScore from "./TeamScore";

const ScoreUpdate = ({
	awayScore,
	homeScore,
	handleBlur,
	handleChange,
	touched,
	errors
}) => {
	const classes = updateFieldSelectorStyles();

	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const awayTeam = teamState.awayTeam();

	const { state: gameContextState } = useGameContextContext();
	const swapTeams = gameContextState.swapTeams();

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection={swapTeams ? "row-reverse" : "row"}
		>
			<TeamScore
				team={awayTeam}
				score={awayScore}
				name="awayScore"
				onChange={handleChange}
				onBlur={handleBlur}
				helperText={touched.awayScore ? errors.awayScore : ""}
				error={touched.awayScore && Boolean(errors.awayScore)}
				required
				reversed={swapTeams}
			/>
			<Typography className={classes.spacer}>:</Typography>
			<TeamScore
				team={homeTeam}
				score={homeScore}
				name="homeScore"
				onChange={handleChange}
				onBlur={handleBlur}
				helperText={touched.homeScore ? errors.homeScore : ""}
				error={touched.homeScore && Boolean(errors.homeScore)}
				required
				reversed={!swapTeams}
			/>
		</Box>
	);
};

export default ScoreUpdate;
